import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    error: null,
    loading: true,
    environment: 'development',
    browser: '',
    touch: false,
    mobile: false,
    route: '',
    slug: '',
    posts: [],
    scrolling: false,
    noScroll: false,
    overlay: false,
    header: false,
    video: ''
  },

  getters: {
    posts: state => state.posts,
    post: state => state.posts.find(item => item.slug === state.slug),
    welcome: state => state.posts.find(item => item.slug === 'welcome'),
    info: state => state.posts.find(item => item.slug === 'more-info'),
    highlights: state => state.posts.filter(item => item.type === 'highlight'),
    highlight: (state) => {
      if (state.route.params && state.route.params.highlight_id) {
        return state.posts.find(item => item.slug === state.route.params.highlight_id)
      }
      return undefined
    },
    categories: (state) => {
      const facilities = state.posts.filter(item => item.category === 'facilities')
      const subjects = state.posts.filter(item => item.category === 'subjects')
      const accommodation = state.posts.filter(item => item.category === 'accommodation')
      const life = state.posts.filter(item => item.category === 'life')
      return [
        {
          category: 'facilities',
          title: 'Facilities',
          tours: [
            ...facilities
          ]
        },
        {
          category: 'subjects',
          title: 'Subject areas',
          tours: [
            ...subjects
          ]
        },
        {
          category: 'accommodation',
          title: 'Accommodation',
          tours: [
            ...accommodation
          ]
        },
        {
          category: 'life',
          title: 'Student life',
          tours: [
            ...life
          ]
        }
      ]
    },
    category: (state) => {
      if (state.route.params && state.route.params.tour_id) {
        return state.posts.find(item => item.slug === state.route.params.tour_id)
      }
      return undefined
    },
    panorama: (state) => {
      if (state.route.params && state.route.params.pano_id) {
        return state.posts.find(item => item.slug === state.route.params.pano_id)
      } else if (state.route.params && state.route.params.highlight_id && state.route.params.media_id) {
        return state.posts.filter(item => item.type === 'panorama').find(item => item.slug === state.slug)
      }

      return state.posts.find(({ type }) => type === 'panorama')
    },
    scrollActiveLinks: (state, getters) => {
      const highlightsArr = getters.highlights.map(({ slug, title }) => ({ slug, title }))

      const welcomeLink = {
        slug: 'welcome',
        title: 'Welcome'
      }

      const moreInfoLink = {
        slug: 'more-info',
        title: 'More info'
      }

      return [
        welcomeLink,
        ...highlightsArr,
        moreInfoLink
      ]
    }
  },

  mutations: {
    browser(state, browser) {
      state.browser = browser
    },
    environment(state, environment) {
      state.environment = environment
    },
    isLoading(state, loading) {
      state.loading = loading
    },
    isTouch(state) {
      state.touch = true
    },
    isMobile(state, mobile) {
      state.mobile = mobile
    },
    scrolling(state, scrolling) {
      state.scrolling = scrolling
    },
    noScroll(state, noScroll) {
      state.noScroll = noScroll
    },
    overlay(state) {
      state.overlay = !state.overlay
    },
    header(state, headerVisible) {
      state.header = headerVisible
    },
    video(state, video) {
      state.video = video
    },
    route(state, route) {
      const slug = route.path.split('/').pop() || '/'
      state.route = route
      state.slug = slug
    },
    populate(state, { posts, error } = {}) {
      state.error = error
// console.log(posts.filter(({ type }) => type === 'panorama'))
      const data = posts
        .map((item) => {
          const acf = item.acf
          return {
            title: item.title.rendered,
            type: item.type,
            slug: item.slug,
            id: item.id,
            order: item.menu_order,
            ...acf
          }
        })

      const pages = data
        .filter(item => item.type === 'page')

      const media = data
        .filter(item => item.type === 'video' || item.type === 'gallery' || item.type === 'post')
        .map((item) => {
          switch (item.type) {
          case 'video':
            item.color = 'accent-1'
            item.slug = `${item.slug}-${item.type}`
            item.typeHeading = 'Video'
            break
          case 'gallery':
            item.color = 'accent-2'
            item.slug = `${item.slug}-${item.type}`
            item.typeHeading = 'Gallery'
            break
          case 'post':
            item.color = 'accent-3'
            item.slug = `${item.slug}-${item.type}`
            item.typeHeading = 'Article'
            break
          default:
            item.color = ''
          }
          return item
        })

      const panoramas = data
        .filter(item => item.type === 'panorama')
        .map((item) => {
          const children = item.children ? item.children
            .map(({ entry }) => data.find(o => o.id === entry.ID)) : []

          const hotspots = children
            .map((o, i) => ({
              ...o, ...item.children[i].position
            }))

          return {
            ...item,
            children: hotspots
          }
        })

      const tours = data
        .filter(item => item.type === 'tour')
        .map((item) => {
          const children = item.children.map(({ ID }) => panoramas.find(o => o.id === ID))

          return {
            ...item,
            children: children
          }
        })

      const highlights = data
        .filter(item => item.type === 'highlight')
        .map((item) => {
          // Replace posts provided from ACF, with the processed data post
          const children = item.children.map(({ID}) => data.find(o => o.id === ID))
          const video = media.find(o => o.id === item.primary_video.ID)

          return {
            ...item,
            children: children,
            primaryVideo: video
          }
        })

      state.posts = [
        ...pages,
        ...highlights,
        ...media,
        ...tours,
        ...panoramas
      ]
    }
  }
})

export default store
